import request from '@/utils/request'

/**
 * 获取通讯录页面组织架构
 */
export function getGroupReport() {
  return request({
    url: 'api/getGroupReport',
    method: 'get'
  })
}

/**
 * 获取部门下的部门
 */
export function getDeptDept(data) {
  return request({
    url: 'api/getDeptDept',
    method: 'post',
    params: data
  })
}

/**
 * 获取部门下的人
 */
export function getDeptEmp(data) {
  return request({
    url: 'api/getEmpList',
    method: 'post',
    params: data
  })
}

/**
 * 通讯录搜索（人和部门）
 */
export function addressBookSearch(data) {
  return request({
    url: 'api/addressBookSearch',
    method: 'post',
    params: data
  })
}


/**
 * 获取组织下的部门
 */
export function getGroupDept(data) {
  return request({
    url: 'api/getGroupDept',
    method: 'post',
    params: data
  })
}

/**
 * 获取经销商通讯录页面组织架构
 */
export function getDealerGroupReport(data) {
  return request({
    url: 'api/getDealerGroupReport',
    method: 'post',
    params: data
  })
}

